import {
  BankAccountType,
  BankType,
  ChartOfAccountPaymentNotDisplayPayment,
  DefaultRevenueDeductType,
  EmployeeWelfareFundCalculationType,
  EmployeeWelfareFundParticipation,
  IssuedPeakAccountStatusType,
  NetIncomeTaxType,
  RevenueDeductType,
  SalaryOrderType,
  SalaryStatusType,
  SalaryTableStatusType,
  SocialSecurityRevenueCalculationType,
  SummarySalaryOrderType,
  SummarySalaryTableStatusType,
  TaxRevenueCalculationType,
} from "@/enums/enums";
import {
  AutoCalculateWhtSalaryCreate,
  GetCreateEmployeeTemplate,
  GetEditEmployeeTemplate,
} from "@/helper/employeeHelper";
import { maximumSettingSSOAmount2026To2028 } from "@/helper/settingHelper";
import { NewObject } from "@/helper/shareHelper";
import { i18n } from "@/i18n";
import { AllowanceData, CreateEmployeeModel } from "@/model/employee/employeeModel";
import { SalaryEmployeeTotalYearlyModel } from "@/model/employee/salaryEmployeeTotalYearlyModel";
import { RevenueDeductModel } from "@/model/revenueDeduct/revenueDeductModel";
import { SalaryDetailModel, SalaryEWFDetailModel } from "@/model/salary/salaryDetailModel";
import {
  PaymentModel,
  PaymentTransactionBankAccountModel,
  PaymentTransactionChartOfAccountModel,
  PndItemModel,
  SalaryBookmarkModel,
  SalaryEmployeeModel,
  SalaryEmployeeRevenueDeductEWFModel,
  SalaryEmployeeRevenueDeductModel,
  SalaryEmployeeRevenueDeductPayRunModel,
  SalaryModel,
  SummarySalaryDetailModel,
  SummarySalaryEmployeePayrunForPaperModel,
  SummarySalaryEmployeePayrunModel,
  SummarySalaryTableViewModel,
} from "@/model/salary/salaryModel";
import { SalaryTableViewModel } from "@/model/salary/salaryTableViewModel";
import { SettingDetailModel } from "@/model/setting/settingDetailModel";
import { WhtCertificateItemModel, WhtCertificateModel } from "@/model/tax/whtCertificateModel";

function SwapArrayElement(arr: any, indexA: number, indexB: number) {
  const temp = arr[indexA];
  arr[indexA] = arr[indexB];
  arr[indexB] = temp;
}

function ConvertToPaymentAndReferenceJournalDetail(paymentRaw: any, transactionId: number) {
  const payment = {
    transactionId: transactionId,
    transactionType: 2,
    paymentGroupList: [] as any[],
  };
  if (paymentRaw.paymentGroupList) {
    for (const paymentGroup of paymentRaw.paymentGroupList) {
      const _paymentGroup = {
        id: paymentGroup.id,
        paymentTransactionBankAccountList: [] as any[],
        paymentTransactionChartOfAccountList: [] as any[],
        paymentTransactionDocumentList: [] as any[],
        whtPayment: {
          id: paymentGroup.whtPayment.id,
          isWht: paymentGroup.whtPayment.isWht,
          whtAmountType: paymentGroup.whtPayment.whtAmountTypeId,
          whtAmount: paymentGroup.whtPayment.whtAmount,
          pndType: paymentGroup.whtPayment.pndType,
        },
        paymentGroupDate: paymentGroup.paymentGroupDate,
        isApproved: paymentGroup.isApproved,
        transactionId: paymentGroup.transactionId,
        transactionType: paymentGroup.transactionType,
        transactionNumber: paymentGroup.transactionNumber,
        referenceTransactionId: paymentGroup.referenceTransactionId,
        referenceTransactionType: paymentGroup.referenceTransactionType,
        referenceTransactionNumber: paymentGroup.referenceTransactionNumber,
        referenceJournalList: [] as any[],
        paymentGroupTotal: 0,
        totalPaidPaymentWithOutChartOfAccount: 0,
      };
      _paymentGroup.totalPaidPaymentWithOutChartOfAccount += paymentGroup.whtPayment.whtAmount;
      if (paymentGroup.referenceJournalList && paymentGroup.referenceJournalList.length > 0) {
        for (const referenceJournal of paymentGroup.referenceJournalList) {
          _paymentGroup.referenceJournalList.push({
            journalId: referenceJournal.journalId,
            journalNumber: referenceJournal.journalNumber,
            isDeleted: referenceJournal.isDeleted,
            journalLockStatus: referenceJournal.journalLockStatus,
          });
        }
      }
      if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
        for (const paymentTransactionBankAccount of paymentGroup.paymentTransactionBankAccountList) {
          const _paymentTransactionBankAccount = {
            bankAccountId: paymentTransactionBankAccount.bankAccountId,
            bankAccountCode: paymentTransactionBankAccount.bankAccountCode,
            isCheque: paymentTransactionBankAccount.isCheque,
            cheque: paymentTransactionBankAccount.isCheque
              ? {
                  chequeId: paymentTransactionBankAccount.cheque.id,
                }
              : {},
            paymentAmount: paymentTransactionBankAccount.paymentAmount,
            remark: paymentTransactionBankAccount.remark,
          };
          _paymentGroup.totalPaidPaymentWithOutChartOfAccount += _paymentTransactionBankAccount.paymentAmount;
          _paymentGroup.paymentTransactionBankAccountList.push(_paymentTransactionBankAccount);
        }
      }
      if (
        paymentGroup.paymentTransactionChartOfAccountList &&
        paymentGroup.paymentTransactionChartOfAccountList.length > 0
      ) {
        for (const paymentTransactionChartAccount of paymentGroup.paymentTransactionChartOfAccountList) {
          const _paymentTransactionChartAccount = {
            accountId: paymentTransactionChartAccount.accountId,
            accountCode: paymentTransactionChartAccount.accountCode,
            paymentAmount: paymentTransactionChartAccount.paymentAmount.ToNumber(),
            remark: paymentTransactionChartAccount.remark,
          };
          _paymentGroup.paymentGroupTotal += _paymentTransactionChartAccount.paymentAmount;
          _paymentGroup.paymentTransactionChartOfAccountList.push(_paymentTransactionChartAccount);
        }
      }
      if (paymentGroup.paymentTransactionDocumentList && paymentGroup.paymentTransactionDocumentList.length > 0) {
        for (const paymentTransactionDocument of paymentGroup.paymentTransactionDocumentList) {
          const _paymentTransactionDocument = {
            transactionId: paymentTransactionDocument.transactionId,
            transactionTypeId: paymentTransactionDocument.transactionTypeId,
            transactionNumber: paymentTransactionDocument.transactionNumber,
            paymentAmount: paymentTransactionDocument.paymentAmount,
            remark: paymentTransactionDocument.remark,
          };
          _paymentGroup.paymentTransactionDocumentList.push(_paymentTransactionDocument);
        }
      }

      _paymentGroup.paymentGroupTotal += _paymentGroup.totalPaidPaymentWithOutChartOfAccount;
      payment.paymentGroupList.push(_paymentGroup);
    }
  }
  return payment;
}

export const GetAllowanceData = (employeeTemplate: any) => {
  return {
    allowancePersonal: employeeTemplate.defaultAllowancePersonal.value.ToNumber() || 0,
    allowanceSpouse: employeeTemplate.defaultAllowanceSpouse.value.ToNumber() || 0,
    allowancePersonCare: employeeTemplate.defaultAllowancePersonCare.value.ToNumber() || 0,
    allowanceChild: employeeTemplate.defaultAllowanceChild.value.ToNumber() || 0,
    allowanceLifeInsurance: employeeTemplate.defaultAllowanceLifeInsurance.value.ToNumber() || 0,
    allowanceHealthInsurance: employeeTemplate.defaultAllowanceHealthInsurance.value.ToNumber() || 0,
    allowanceFundContribution: employeeTemplate.defaultAllowanceFundContribution.value.ToNumber() || 0,
    allowanceSocialSecurityContributions:
      employeeTemplate.defaultAllowanceSocialSecurityContributions.value.ToNumber() || 0,
    allowanceFund: employeeTemplate.defaultAllowanceFund.value.ToNumber() || 0,
    allowanceOther: employeeTemplate.defaultAllowanceOther.value.ToNumber() || 0,
  };
};

export const GetContactInfo = (employeeTemplate: any) => {
  return {
    namePrefixType: employeeTemplate.prefixName.value,
    namePrefixName: employeeTemplate.prefixNameOther.value,
    firstNameTh: employeeTemplate.firstNameTH.value,
    firstNameEn: employeeTemplate.firstNameEN.value,
    lastNameTh: employeeTemplate.lastNameTH.value,
    lastNameEn: employeeTemplate.lastNameEN.value,
  };
};

export const GetTotalAllowance = (allowanceData: AllowanceData) => {
  if (!allowanceData) return 0;
  return (
    (allowanceData.allowancePersonal || 0) +
    (allowanceData.allowanceSpouse || 0) +
    (allowanceData.allowancePersonCare || 0) +
    (allowanceData.allowanceChild || 0) +
    (allowanceData.allowanceLifeInsurance || 0) +
    (allowanceData.allowanceHealthInsurance || 0) +
    (allowanceData.allowanceFundContribution || 0) +
    (allowanceData.allowanceSocialSecurityContributions || 0) +
    (allowanceData.allowanceFund || 0) +
    (allowanceData.allowanceOther || 0)
  );
};

export default {
  GetSalaryDefault(salaryEmployeeList: any = []) {
    return {
      id: 0,
      number: {
        value: "",
        isDisabled: false,
        isValidateError: false,
      },
      issuedDate: {
        date: "",
        isDisabled: false,
        isValidateDateError: false,
        isNotAuto: false,
      },
      dueDate: {
        date: "",
        isDisabled: false,
        isValidateDateError: false,
      },
      fromDate: {
        date: "",
        isDisabled: false,
        isValidateDateError: false,
      },
      toDate: {
        date: "",
        isDisabled: false,
        isValidateDateError: false,
      },
      salaryEmployeeList: salaryEmployeeList,
      summary: {
        salaryTotal: "0.00",
        revenueTotal: "0.00",
        deductionTotal: "0.00",
        whtPayableTotal: "0.00",
        socialSecurityFundTotal: "0.00",
        socialSecurityPayableTotal: "0.00",
        socialSecurityCalculatedAmount: "0.00",
        employeeWelfareFundTotal: "0.00",
        employeeWelfareFundPayableTotal: "0.00",
        employeeWelfareFundCalculatedAmount: "0.00",
        whtTotal: "0.00",
        netAmount: "0.00",
        taxCalculatedAmount: "0.00",
        grossSalaryAmount: "0.00",
        regularTotal: "0.00",
        irregularTotal: "0.00",
        socialSecurityEmployer: {
          socialSecurityEmployerTotal: "0.00",
          socialSecurityEmployerTotalDefault: "0.00",
          isNotAuto: false,
          isDisabled: false,
        },
        employeeWelfareFundEmployer: {
          employeeWelfareFundEmployerTotal: "0.00",
          employeeWelfareFundEmployerTotalDefault: "0.00",
          isNotAuto: false,
          isDisabled: false,
        },
      },
    };
  },
  GetSalaryEmployeeRevenueDeductDefault(revenueDeduct: any) {
    return {
      revenueDeduct: {
        value: revenueDeduct,
        isDisabled: false,
      },
      total: {
        value: "0.00",
        isDisabled: true,
      },
    };
  },
  SwapArrayRevenueDeduct(employeeRevenueDeductList: Array<RevenueDeductModel>) {
    let swapIndex = 0;

    employeeRevenueDeductList = employeeRevenueDeductList.sort((a: RevenueDeductModel, b: RevenueDeductModel) =>
      a.revenueDeductType ? 1 : -1,
    );

    let salary = 0;
    for (let i = 0; i < employeeRevenueDeductList.length; i++) {
      if (employeeRevenueDeductList[i].type == DefaultRevenueDeductType.Salary) {
        salary = i;
        break;
      }
    }
    if (salary > 0) {
      SwapArrayElement(employeeRevenueDeductList, salary, 0);
    }

    let socialSecurityFund = 0;
    for (let i = 0; i < employeeRevenueDeductList.length; i++) {
      if (employeeRevenueDeductList[i].type == DefaultRevenueDeductType.SocialSecurityFund) {
        socialSecurityFund = i;
        break;
      }
    }
    if (socialSecurityFund > 0) {
      SwapArrayElement(employeeRevenueDeductList, socialSecurityFund, employeeRevenueDeductList.length - ++swapIndex);
    }

    let withHoldingTaxIndex = 0;
    for (let i = 0; i < employeeRevenueDeductList.length; i++) {
      if (employeeRevenueDeductList[i].type == DefaultRevenueDeductType.WithHoldingTax) {
        withHoldingTaxIndex = i;
        break;
      }
    }
    if (withHoldingTaxIndex > 0) {
      SwapArrayElement(employeeRevenueDeductList, withHoldingTaxIndex, employeeRevenueDeductList.length - ++swapIndex);
    }
  },
  GetSalaryEmployeeDefault(revenueDeductList: any = []) {
    return {
      employee: {
        value: {
          id: 0,
        },
        isDisabled: false,
        isNotAuto: true,
        isValidateDateError: false,
      },
      revenueDeduct: {
        revenueDeductList: NewObject(revenueDeductList),
        isDisabled: false,
      },
      summary: {
        providentFundTotal: "0.00",
        taxCalculatedAmount: "0.00",
        grossSalaryAmount: "0.00",
        regularTotal: "0.00",
        irregularTotal: "0.00",
        salaryTotal: "0.00",
        revenueTotal: "0.00",
        deductionTotal: "0.00",
        whtTotal: "0.00",
        netAmount: "0.00",
        socialSecurity: {
          socialSecurityCalculatedAmount: "0.00",
          socialSecurityFundTotalDefault: "0.00",
          socialSecurityFundTotal: "0.00",
          isNotAuto: false,
        },
        employeeWelfare: {
          employeeWelfareFundCalculatedAmount: "0.00",
          employeeWelfareFundTotalDefault: "0.00",
          employeeWelfareFundTotal: "0.00",
          isNotAuto: false,
        },
      },
      isShow: false,
    };
  },
  SalaryCreateValidated(salary: any) {
    if (salary.salaryEmployeeList.length > 0) {
      salary.salaryEmployeeList.forEach((salary: any) => {
        if (!salary.employee.value || (salary.employee.value && salary.employee.value.id == 0)) {
          salary.employee.isValidateDateError = true;
        } else {
          salary.employee.isValidateDateError = false;
        }
      });
    }
  },
  CheckSalaryCreateValidated(salaryRaw: any) {
    let salaryCreateValidated = true;
    if (salaryRaw.salaryEmployeeList.length > 0) {
      salaryRaw.salaryEmployeeList.forEach((salary: any) => {
        if (salary.employee.isValidateDateError) {
          salaryCreateValidated = false;
        }
      });
    } else {
      salaryCreateValidated = false;
    }
    if (salaryRaw.number.isValidateError) {
      salaryCreateValidated = false;
    }
    if (new Date(salaryRaw.dueDate.date) < new Date(salaryRaw.issuedDate.date)) {
      salaryCreateValidated = false;
      salaryRaw.dueDate.isValidateDateError = true;
    }
    if (new Date(salaryRaw.fromDate.date) > new Date(salaryRaw.toDate.date)) {
      salaryCreateValidated = false;
      salaryRaw.toDate.isValidateDateError = true;
    }
    return salaryCreateValidated;
  },
  ConvertToSalaryCreate(salaryRaw: any, status: SalaryStatusType, isIssuedExpense: boolean): SalaryModel {
    const salary: SalaryModel = {
      id: salaryRaw.id,
      number: salaryRaw.number.value,
      issuedDate: salaryRaw.issuedDate.date,
      dueDate: salaryRaw.dueDate.date,
      fromDate: salaryRaw.fromDate.date,
      toDate: salaryRaw.toDate.date,
      status: status,
      salaryTotal: salaryRaw.summary.salaryTotal,
      revenueTotal: salaryRaw.summary.revenueTotal,
      deductionTotal: salaryRaw.summary.deductionTotal,
      whtPayableTotal: salaryRaw.summary.whtPayableTotal,
      socialSecurityPayableTotal: salaryRaw.summary.socialSecurityPayableTotal,
      socialSecurityEmployerTotal: salaryRaw.summary.socialSecurityEmployer.socialSecurityEmployerTotal,
      socialSecurityEmployeeTotal: salaryRaw.summary.socialSecurityFundTotal,
      whtTotal: salaryRaw.summary.whtTotal,
      netAmount: salaryRaw.summary.netAmount,
      taxCalculatedAmount: salaryRaw.summary.taxCalculatedAmount,
      socialSecurityCalculatedAmount: salaryRaw.summary.socialSecurityCalculatedAmount,
      grossSalaryAmount: salaryRaw.summary.grossSalaryAmount,
      regularTotal: salaryRaw.summary.regularTotal,
      irregularTotal: salaryRaw.summary.irregularTotal,
      employeeList: [],
      issuedSalaryExpenseStatusType: isIssuedExpense
        ? IssuedPeakAccountStatusType.IssuedWhenCreatedSalary
        : IssuedPeakAccountStatusType.None,
      employeeWelfareFundPayableTotal: salaryRaw.summary.employeeWelfareFundPayableTotal,
      employeeWelfareFundEmployerTotal: salaryRaw.summary.employeeWelfareFundEmployer.employeeWelfareFundEmployerTotal,
      employeeWelfareFundEmployeeTotal: salaryRaw.summary.employeeWelfareFundTotal,
    };

    if (salaryRaw.salaryEmployeeList && salaryRaw.salaryEmployeeList.length > 0) {
      for (const salaryEmployeeRaw of salaryRaw.salaryEmployeeList) {
        if (salaryEmployeeRaw.employee.value.id != 0) {
          const salaryEmployee: SalaryEmployeeModel = {
            id: 0,
            salaryId: 0,
            employeeId: salaryEmployeeRaw.employee.value.id,
            positionId: salaryEmployeeRaw.employee.value.positionId,
            departmentId: salaryEmployeeRaw.employee.value.departmentId,
            salaryTotal: salaryEmployeeRaw.summary.salaryTotal,
            revenueTotal: salaryEmployeeRaw.summary.revenueTotal,
            deductionTotal: salaryEmployeeRaw.summary.deductionTotal,
            whtTotal: salaryEmployeeRaw.summary.whtTotal,
            netAmount: salaryEmployeeRaw.summary.netAmount,
            socialSecurityFundTotal: salaryEmployeeRaw.summary.socialSecurity.socialSecurityFundTotal,
            providentFundTotal: salaryEmployeeRaw.summary.providentFundTotal,
            taxCalculatedAmount: salaryEmployeeRaw.summary.taxCalculatedAmount,
            socialSecurityCalculatedAmount: salaryEmployeeRaw.summary.socialSecurity.socialSecurityCalculatedAmount,
            grossSalaryAmount: salaryEmployeeRaw.summary.grossSalaryAmount,
            regularTotal: salaryEmployeeRaw.summary.regularTotal,
            irregularTotal: salaryEmployeeRaw.summary.irregularTotal,
            revenueDeductList: [],
            employeeWelfareFundTotal: salaryEmployeeRaw.summary.employeeWelfare.employeeWelfareFundTotal,
            employeeWelfareFundCalculatedAmount:
              salaryEmployeeRaw.summary.employeeWelfare.employeeWelfareFundCalculatedAmount,
          };
          if (
            salaryEmployeeRaw.revenueDeduct &&
            salaryEmployeeRaw.revenueDeduct.revenueDeductList &&
            salaryEmployeeRaw.revenueDeduct.revenueDeductList.length > 0
          ) {
            for (const salaryEmployeeRevenueDeductRaw of salaryEmployeeRaw.revenueDeduct.revenueDeductList) {
              if (salaryEmployeeRevenueDeductRaw.total.value.ToAccountingRoundUp() != 0) {
                let accountId = salaryEmployeeRevenueDeductRaw.revenueDeduct.value.accountId;
                if (!(accountId > 0)) {
                  accountId = salaryEmployeeRaw.employee.value.accountId;
                }
                const salaryEmployeeRevenueDeduct: SalaryEmployeeRevenueDeductModel = {
                  id: 0,
                  salaryEmployeeId: 0,
                  revenueDeductId: salaryEmployeeRevenueDeductRaw.revenueDeduct.value.id,
                  revenueDeductType: salaryEmployeeRevenueDeductRaw.revenueDeduct.value.revenueDeductType,
                  total: salaryEmployeeRevenueDeductRaw.total.value.ToNumber(),
                  accountId: accountId > 0 ? accountId : 0,
                };
                salaryEmployee.revenueDeductList.push(salaryEmployeeRevenueDeduct);
              }
            }
          }
          salary.employeeList.push(salaryEmployee);
        }
      }
    }
    return salary;
  },
  ConvertToSalaryBookmarkModel(salaryRaw: any, input: any): SalaryBookmarkModel {
    const bookmark: SalaryBookmarkModel = {
      id: salaryRaw.id,
      bookmarkName: input.name,
      bookmarkDescription: input.description,
      isSaveRevenue: input.isSaveRevenue,
      isSaveDeduct: input.isSaveDeduct,
      number: salaryRaw.number.value,
      issuedDate: salaryRaw.issuedDate.date,
      dueDate: salaryRaw.dueDate.date,
      fromDate: salaryRaw.fromDate.date,
      toDate: salaryRaw.toDate.date,
      salaryTotal: salaryRaw.summary.salaryTotal,
      revenueTotal: salaryRaw.summary.revenueTotal,
      deductionTotal: salaryRaw.summary.deductionTotal,
      whtPayableTotal: salaryRaw.summary.whtPayableTotal,
      socialSecurityPayableTotal: salaryRaw.summary.socialSecurityPayableTotal,
      socialSecurityEmployerTotal: salaryRaw.summary.socialSecurityEmployer.socialSecurityEmployerTotal,
      socialSecurityEmployeeTotal: salaryRaw.summary.socialSecurityFundTotal,
      whtTotal: salaryRaw.summary.whtTotal,
      netAmount: salaryRaw.summary.netAmount,
      taxCalculatedAmount: salaryRaw.summary.taxCalculatedAmount,
      socialSecurityCalculatedAmount: salaryRaw.summary.socialSecurityCalculatedAmount,
      grossSalaryAmount: salaryRaw.summary.grossSalaryAmount,
      regularTotal: salaryRaw.summary.regularTotal,
      irregularTotal: salaryRaw.summary.irregularTotal,
      employeeList: [],
      issuedSalaryExpenseStatusType: IssuedPeakAccountStatusType.None,
      employeeWelfareFundPayableTotal: salaryRaw.summary.employeeWelfareFundPayableTotal,
      employeeWelfareFundEmployerTotal: salaryRaw.summary.employeeWelfareFundEmployer.employeeWelfareFundEmployerTotal,
      employeeWelfareFundEmployeeTotal: salaryRaw.summary.employeeWelfareFundTotal,
    };

    if (salaryRaw.salaryEmployeeList && salaryRaw.salaryEmployeeList.length > 0) {
      for (const salaryEmployeeRaw of salaryRaw.salaryEmployeeList) {
        if (salaryEmployeeRaw.employee.value.id != 0) {
          const salaryEmployee: SalaryEmployeeModel = {
            id: 0,
            salaryId: 0,
            employeeId: salaryEmployeeRaw.employee.value.id,
            positionId: salaryEmployeeRaw.employee.value.positionId,
            departmentId: salaryEmployeeRaw.employee.value.departmentId,
            salaryTotal: salaryEmployeeRaw.summary.salaryTotal,
            revenueTotal: salaryEmployeeRaw.summary.revenueTotal,
            deductionTotal: salaryEmployeeRaw.summary.deductionTotal,
            whtTotal: salaryEmployeeRaw.summary.whtTotal,
            netAmount: salaryEmployeeRaw.summary.netAmount,
            socialSecurityFundTotal: salaryEmployeeRaw.summary.socialSecurity.socialSecurityFundTotal,
            socialSecurityCalculatedAmount: salaryEmployeeRaw.summary.socialSecurity.socialSecurityCalculatedAmount,
            providentFundTotal: salaryEmployeeRaw.summary.providentFundTotal,
            taxCalculatedAmount: salaryEmployeeRaw.summary.taxCalculatedAmount,
            grossSalaryAmount: salaryEmployeeRaw.summary.grossSalaryAmount,
            regularTotal: salaryEmployeeRaw.summary.regularTotal,
            irregularTotal: salaryEmployeeRaw.summary.irregularTotal,
            employeeWelfareFundTotal: salaryEmployeeRaw.summary.employeeWelfare.employeeWelfareFundTotal,
            employeeWelfareFundCalculatedAmount:
              salaryEmployeeRaw.summary.employeeWelfare.employeeWelfareFundCalculatedAmount,
            revenueDeductList: [],
          };

          if (
            salaryEmployeeRaw.revenueDeduct &&
            salaryEmployeeRaw.revenueDeduct.revenueDeductList &&
            salaryEmployeeRaw.revenueDeduct.revenueDeductList.length > 0
          ) {
            for (const salaryEmployeeRevenueDeductRaw of salaryEmployeeRaw.revenueDeduct.revenueDeductList) {
              if (salaryEmployeeRevenueDeductRaw.total.value.ToAccountingRoundUp() != 0) {
                let accountId = salaryEmployeeRevenueDeductRaw.revenueDeduct.value.accountId;
                if (!(accountId > 0)) {
                  accountId = salaryEmployeeRaw.employee.value.accountId;
                }
                const salaryEmployeeRevenueDeduct: SalaryEmployeeRevenueDeductModel = {
                  id: 0,
                  salaryEmployeeId: 0,
                  revenueDeductId: salaryEmployeeRevenueDeductRaw.revenueDeduct.value.id,
                  revenueDeductType: salaryEmployeeRevenueDeductRaw.revenueDeduct.value.revenueDeductType,
                  total: salaryEmployeeRevenueDeductRaw.total.value.ToNumber(),
                  accountId: accountId > 0 ? accountId : 0,
                };
                salaryEmployee.revenueDeductList.push(salaryEmployeeRevenueDeduct);
              }
            }
          }
          bookmark.employeeList.push(salaryEmployee);
        }
      }
    }
    return bookmark;
  },
  GetSocialSecurityFundTotal(salaryEmployee: any, setting: SettingDetailModel) {
    let socialSecurityFundTotal = 0;
    let socialSecurityCalculatedAmount = 0;
    if (salaryEmployee.revenueDeduct.revenueDeductList && salaryEmployee.revenueDeduct.revenueDeductList) {
      for (const revenueDeduct of salaryEmployee.revenueDeduct.revenueDeductList) {
        if (
          revenueDeduct.revenueDeduct.value.socialSecurityRevenueCalculationType ==
          SocialSecurityRevenueCalculationType.Include
        ) {
          socialSecurityCalculatedAmount +=
            (revenueDeduct.revenueDeduct.value.revenueDeductType == RevenueDeductType.Deduction ? -1 : 1) *
            revenueDeduct.total.value.ToNumber();
        }
      }
    }
    let socialSecurityFundContributionRate = 5;
    let socialSecurityFundContributionMaxTotal = maximumSettingSSOAmount2026To2028;
    if (setting) {
      if (setting.isRegisteredSSO) {
        if (salaryEmployee.employee.value.isRegisterSSO) {
          socialSecurityFundContributionRate = setting.socialSecurityFundContributionRate;
          socialSecurityFundContributionMaxTotal = setting.socialSecurityFundContributionMaxTotal;
        } else {
          socialSecurityFundContributionRate = 1;
          socialSecurityFundContributionMaxTotal = 0;
          salaryEmployee.revenueDeduct.revenueDeductList.forEach((revenueDeduct: any) => {
            if (revenueDeduct.revenueDeduct.value.type == DefaultRevenueDeductType.SocialSecurityFund) {
              revenueDeduct.total.isDisabled = true;
            }
          });
        }
      } else {
        socialSecurityFundContributionRate = 1;
        socialSecurityFundContributionMaxTotal = 0;
      }
    }
    socialSecurityFundTotal =
      (socialSecurityCalculatedAmount.ToNumber() * socialSecurityFundContributionRate.ToNumber()) / 100;
    socialSecurityFundTotal =
      socialSecurityFundTotal.ToNumber() > socialSecurityFundContributionMaxTotal.ToNumber()
        ? socialSecurityFundContributionMaxTotal
        : socialSecurityFundTotal;
    return socialSecurityFundTotal;
  },
  GetEmployeeWelfareFundEmployeeTotal(salaryEmployee: any, setting: SettingDetailModel) {
    let employeeWelfareFundEmployeeTotal = 0;
    let employeeWelfareFundCalculatedAmount = 0;

    if (salaryEmployee.revenueDeduct?.revenueDeductList?.length > 0) {
      for (const { revenueDeduct, total } of salaryEmployee.revenueDeduct.revenueDeductList) {
        if (revenueDeduct.value.employeeWelfareFundCalculationType === EmployeeWelfareFundCalculationType.Include) {
          employeeWelfareFundCalculatedAmount +=
            (revenueDeduct.value.revenueDeductType === RevenueDeductType.Deduction ? -1 : 1) * total.value.ToNumber(); // sum if calculate type is include EWF
        }
      }
    }

    let employeeWelfareFundEmployeeRate = 0; // 0%

    const isSettingRegistered: boolean = Boolean(
      setting &&
        (setting.employeeWelfareFundParticipation === EmployeeWelfareFundParticipation.MandatoryParticipation ||
          setting.employeeWelfareFundParticipation === EmployeeWelfareFundParticipation.VoluntaryParticipation),
    );
    const isEmployeeRegistered = salaryEmployee.employee.value.isRegisterEWF;

    if (isSettingRegistered && isEmployeeRegistered) {
      employeeWelfareFundEmployeeRate = setting.employeeWelfareFundEmployeeRate; // will set rate by setting EWF as percentage
    }

    employeeWelfareFundEmployeeTotal =
      (employeeWelfareFundCalculatedAmount.ToNumber() * employeeWelfareFundEmployeeRate.ToNumber()) / 100; // it will be 0.00 if rate is 0%

    return employeeWelfareFundEmployeeTotal;
  },
  GetSalaryEmployeeSummary(salaryEmployee: any) {
    const salaryEmployeeSummary = {
      providentFundTotal: 0,
      taxCalculatedAmount: 0,
      grossSalaryAmount: 0,
      regularTotal: 0,
      irregularTotal: 0,
      salaryTotal: 0,
      revenueTotal: 0,
      deductionTotal: 0,
      whtTotal: 0,
      netAmount: 0,
      socialSecurity: {
        socialSecurityCalculatedAmount: 0,
        socialSecurityFundTotalDefault: 0,
        socialSecurityFundTotal: 0,
        isNotAuto: false,
      },
      employeeWelfare: {
        employeeWelfareFundCalculatedAmount: 0,
        employeeWelfareFundTotalDefault: 0,
        employeeWelfareFundTotal: 0,
        isNotAuto: false,
      },
    };

    if (salaryEmployee?.revenueDeduct?.revenueDeductList?.length > 0) {
      for (const { revenueDeduct, total } of salaryEmployee.revenueDeduct.revenueDeductList) {
        let summaryTotal = 0;

        if (revenueDeduct.value.revenueDeductType === RevenueDeductType.Deduction) {
          salaryEmployeeSummary.deductionTotal += total.value.ToNumber();
          summaryTotal += total.value.ToNumber() * -1;
        } else {
          salaryEmployeeSummary.revenueTotal += total.value.ToNumber();
          summaryTotal += total.value.ToNumber();
        }

        switch (revenueDeduct.value.type) {
          case DefaultRevenueDeductType.Salary:
            salaryEmployeeSummary.salaryTotal += total.value.ToNumber();
            break;
          case DefaultRevenueDeductType.WithHoldingTax:
            salaryEmployeeSummary.whtTotal += total.value.ToNumber();
            break;
          case DefaultRevenueDeductType.ProvidentFund:
            salaryEmployeeSummary.providentFundTotal += total.value.ToNumber();
            break;
          case DefaultRevenueDeductType.SocialSecurityFund:
            salaryEmployeeSummary.socialSecurity.socialSecurityFundTotal += total.value.ToNumber();
            break;
          case DefaultRevenueDeductType.EmployeeWelfareFund:
            salaryEmployeeSummary.employeeWelfare.employeeWelfareFundTotal += total.value.ToNumber();
            break;
        }

        if (revenueDeduct.value.isRegular) {
          salaryEmployeeSummary.regularTotal += summaryTotal.ToNumber();
        } else {
          salaryEmployeeSummary.irregularTotal += summaryTotal.ToNumber();
        }

        if (
          revenueDeduct.value.taxRevenueCalculationType === TaxRevenueCalculationType.IncludeIncomeType401 ||
          revenueDeduct.value.taxRevenueCalculationType === TaxRevenueCalculationType.IncludeIncomeType402
        ) {
          salaryEmployeeSummary.taxCalculatedAmount += summaryTotal.ToNumber();
        }

        if (revenueDeduct.value.socialSecurityRevenueCalculationType === SocialSecurityRevenueCalculationType.Include) {
          salaryEmployeeSummary.socialSecurity.socialSecurityCalculatedAmount += summaryTotal.ToNumber();
        }

        if (revenueDeduct.value.employeeWelfareFundCalculationType === EmployeeWelfareFundCalculationType.Include) {
          salaryEmployeeSummary.employeeWelfare.employeeWelfareFundCalculatedAmount += summaryTotal.ToNumber();
        }

        if (
          ![
            DefaultRevenueDeductType.WithHoldingTax,
            DefaultRevenueDeductType.SocialSecurityFund,
            DefaultRevenueDeductType.EmployeeWelfareFund,
          ].includes(revenueDeduct.value.type)
        ) {
          salaryEmployeeSummary.grossSalaryAmount += summaryTotal.ToNumber();
        }
      }

      salaryEmployeeSummary.socialSecurity.socialSecurityFundTotalDefault =
        salaryEmployee.summary.socialSecurity.socialSecurityFundDefault;
      salaryEmployeeSummary.socialSecurity.isNotAuto = salaryEmployee.summary.socialSecurity.isNotAuto;
      salaryEmployeeSummary.employeeWelfare.employeeWelfareFundTotalDefault =
        salaryEmployee.summary.employeeWelfare.employeeWelfareFundDefault;
      salaryEmployeeSummary.employeeWelfare.isNotAuto = salaryEmployee.summary.employeeWelfare.isNotAuto;
      salaryEmployeeSummary.netAmount = salaryEmployeeSummary.revenueTotal - salaryEmployeeSummary.deductionTotal;
    }

    return salaryEmployeeSummary;
  },
  GetSalarySummaryWithoutSSOAndEWFEmployer(salary: any) {
    const summary = {
      salaryTotal: 0,
      revenueTotal: 0,
      deductionTotal: 0,
      whtPayableTotal: 0,
      socialSecurityFundTotal: 0,
      socialSecurityPayableTotal: 0,
      socialSecurityCalculatedAmount: 0,
      employeeWelfareFundTotal: 0,
      employeeWelfareFundPayableTotal: 0,
      employeeWelfareFundCalculatedAmount: 0,
      whtTotal: 0,
      taxCalculatedAmount: 0,
      grossSalaryAmount: 0,
      regularTotal: 0,
      irregularTotal: 0,
      netAmount: 0,
    };

    if (salary && salary.salaryEmployeeList && salary.salaryEmployeeList.length > 0) {
      for (const salaryEmployee of salary.salaryEmployeeList) {
        summary.salaryTotal += salaryEmployee.summary.salaryTotal.ToNumber();
        summary.revenueTotal += salaryEmployee.summary.revenueTotal.ToNumber();
        summary.deductionTotal += salaryEmployee.summary.deductionTotal.ToNumber();
        summary.whtTotal += salaryEmployee.summary.whtTotal.ToNumber();
        summary.whtPayableTotal += salaryEmployee.summary.whtTotal.ToNumber();
        summary.taxCalculatedAmount += salaryEmployee.summary.taxCalculatedAmount.ToNumber();
        summary.socialSecurityCalculatedAmount +=
          salaryEmployee.summary.socialSecurity.socialSecurityCalculatedAmount.ToNumber();
        summary.socialSecurityFundTotal += salaryEmployee.summary.socialSecurity.socialSecurityFundTotal.ToNumber();
        summary.employeeWelfareFundCalculatedAmount +=
          salaryEmployee.summary.employeeWelfare.employeeWelfareFundCalculatedAmount.ToNumber();
        summary.employeeWelfareFundTotal += salaryEmployee.summary.employeeWelfare.employeeWelfareFundTotal.ToNumber();
        summary.grossSalaryAmount += salaryEmployee.summary.grossSalaryAmount.ToNumber();
        summary.regularTotal += salaryEmployee.summary.regularTotal.ToNumber();
        summary.irregularTotal += salaryEmployee.summary.irregularTotal.ToNumber();
        summary.netAmount += salaryEmployee.summary.netAmount.ToNumber();
      }
    }

    return summary;
  },
  GetSalarySummary(salary: any) {
    const summary = {
      salaryTotal: 0,
      revenueTotal: 0,
      deductionTotal: 0,
      whtPayableTotal: 0,
      socialSecurityFundTotal: 0,
      socialSecurityPayableTotal: 0,
      socialSecurityCalculatedAmount: 0,
      employeeWelfareFundTotal: 0,
      employeeWelfareFundPayableTotal: 0,
      employeeWelfareFundCalculatedAmount: 0,
      whtTotal: 0,
      netAmount: 0,
      taxCalculatedAmount: 0,
      grossSalaryAmount: 0,
      regularTotal: 0,
      irregularTotal: 0,
      socialSecurityEmployer: {
        socialSecurityEmployerTotal: 0,
        socialSecurityEmployerTotalDefault: 0,
        isDisabled: false,
      },
      employeeWelfareFundEmployer: {
        employeeWelfareFundEmployerTotal: 0,
        employeeWelfareFundEmployerTotalDefault: 0,
        isDisabled: false,
      },
    };

    summary.socialSecurityEmployer = NewObject(salary.summary.socialSecurityEmployer);
    summary.employeeWelfareFundEmployer = NewObject(salary.summary.employeeWelfareFundEmployer);

    const salarySummaryWithoutSSOAndEWFEmployer = this.GetSalarySummaryWithoutSSOAndEWFEmployer(salary);

    summary.salaryTotal = salarySummaryWithoutSSOAndEWFEmployer.salaryTotal;
    summary.revenueTotal =
      salarySummaryWithoutSSOAndEWFEmployer.revenueTotal - salarySummaryWithoutSSOAndEWFEmployer.salaryTotal;
    summary.deductionTotal =
      salarySummaryWithoutSSOAndEWFEmployer.deductionTotal -
      (salarySummaryWithoutSSOAndEWFEmployer.whtTotal + salarySummaryWithoutSSOAndEWFEmployer.socialSecurityFundTotal);
    summary.whtPayableTotal = salarySummaryWithoutSSOAndEWFEmployer.whtPayableTotal;
    summary.whtTotal = salarySummaryWithoutSSOAndEWFEmployer.whtTotal;
    summary.taxCalculatedAmount = salarySummaryWithoutSSOAndEWFEmployer.taxCalculatedAmount;
    summary.socialSecurityCalculatedAmount = salarySummaryWithoutSSOAndEWFEmployer.socialSecurityCalculatedAmount;
    summary.grossSalaryAmount = salarySummaryWithoutSSOAndEWFEmployer.grossSalaryAmount;
    summary.regularTotal = salarySummaryWithoutSSOAndEWFEmployer.regularTotal;
    summary.irregularTotal = salarySummaryWithoutSSOAndEWFEmployer.irregularTotal;
    summary.netAmount = salarySummaryWithoutSSOAndEWFEmployer.netAmount;
    summary.socialSecurityFundTotal = salarySummaryWithoutSSOAndEWFEmployer.socialSecurityFundTotal;
    summary.socialSecurityPayableTotal =
      summary.socialSecurityFundTotal.ToNumber() +
      summary.socialSecurityEmployer.socialSecurityEmployerTotal.ToNumber();
    summary.employeeWelfareFundTotal = salarySummaryWithoutSSOAndEWFEmployer.employeeWelfareFundTotal;
    summary.employeeWelfareFundPayableTotal =
      summary.employeeWelfareFundTotal.ToNumber() +
      summary.employeeWelfareFundEmployer.employeeWelfareFundEmployerTotal.ToNumber();

    return summary;
  },
  GetEmployerSocialSecurityTotal(salary: any, setting: SettingDetailModel) {
    let employerSocialSecurityTotal = 0;

    if (salary?.salaryEmployeeList?.length > 0) {
      for (const salaryEmployee of salary.salaryEmployeeList) {
        employerSocialSecurityTotal += this.GetEmployerSocialSecurityTotalPerEmployee(salaryEmployee, setting)
          .ToAccountingRoundUp(0)
          .ToNumber();
      }
    }

    return employerSocialSecurityTotal;
  },
  GetEmployeeWelfareFundEmployerTotal(salary: any, setting: SettingDetailModel) {
    let employeeWelfareFundEmployerTotal = 0;

    if (salary?.salaryEmployeeList?.length > 0) {
      for (const salaryEmployee of salary.salaryEmployeeList) {
        employeeWelfareFundEmployerTotal += this.GetEmployeeWelfareFundEmployerTotalPerEmployee(salaryEmployee, setting)
          .ToAccountingRoundUp(0)
          .ToNumber();
      }
    }

    return employeeWelfareFundEmployerTotal;
  },
  GetEmployerSocialSecurityTotalPerEmployee(salaryEmployee: any, setting: SettingDetailModel) {
    let employerSocialSecurityTotal = 0;
    let employerContritutionRate = 5;
    let employerContritutionMaxTotal = maximumSettingSSOAmount2026To2028;
    if (setting) {
      if (setting.isRegisteredSSO) {
        if (salaryEmployee.employee.value.isRegisterSSO) {
          employerContritutionRate = setting.employerContritutionRate;
          employerContritutionMaxTotal = setting.employerContritutionMaxTotal;
        } else {
          employerContritutionRate = 1;
          employerContritutionMaxTotal = 0;
        }
      } else {
        employerContritutionRate = 1;
        employerContritutionMaxTotal = 0;
      }
    }
    employerSocialSecurityTotal =
      (salaryEmployee.summary.socialSecurity.socialSecurityCalculatedAmount.ToNumber() *
        employerContritutionRate.ToNumber()) /
      100;
    employerSocialSecurityTotal =
      employerSocialSecurityTotal.ToNumber() > employerContritutionMaxTotal.ToNumber()
        ? employerContritutionMaxTotal
        : employerSocialSecurityTotal;
    return employerSocialSecurityTotal;
  },
  GetEmployeeWelfareFundEmployerTotalPerEmployee(salaryEmployee: any, setting: SettingDetailModel) {
    let employeeWelfareFundEmployerRate = 0;

    const isSettingRegistered: boolean = Boolean(
      setting &&
        (setting.employeeWelfareFundParticipation === EmployeeWelfareFundParticipation.MandatoryParticipation ||
          setting.employeeWelfareFundParticipation === EmployeeWelfareFundParticipation.VoluntaryParticipation),
    );
    const isEmployeeRegistered = salaryEmployee.employee.value.isRegisterEWF;

    if (isSettingRegistered && isEmployeeRegistered) {
      employeeWelfareFundEmployerRate = setting.employeeWelfareFundEmployerRate;
    }

    return (
      (salaryEmployee.summary.employeeWelfare.employeeWelfareFundCalculatedAmount.ToNumber() *
        employeeWelfareFundEmployerRate.ToNumber()) /
      100
    );
  },
  CalculateAndSetSocialSecurityTotal(salary: any, setting: SettingDetailModel) {
    const employerSocialSecurityTotal = this.GetEmployerSocialSecurityTotal(salary, setting);

    if (!salary.summary.socialSecurityEmployer.isNotAuto) {
      salary.summary.socialSecurityEmployer.socialSecurityEmployerTotal = employerSocialSecurityTotal;
      salary.summary.socialSecurityEmployer.socialSecurityEmployerTotalDefault = employerSocialSecurityTotal;
    }
  },
  CalculateAndSetEmployeeWelfareFundTotal(salary: any, setting: SettingDetailModel) {
    const employeeWelfareFundEmployerTotal = this.GetEmployeeWelfareFundEmployerTotal(salary, setting);

    if (!salary.summary.employeeWelfareFundEmployer.isNotAuto) {
      salary.summary.employeeWelfareFundEmployer.employeeWelfareFundEmployerTotal = employeeWelfareFundEmployerTotal;
      salary.summary.employeeWelfareFundEmployer.employeeWelfareFundEmployerTotalDefault =
        employeeWelfareFundEmployerTotal;
    }
  },
  SetTapsSalaryTable(tableView: SalaryTableViewModel, tableCount: number) {
    return [
      {
        name: "Table_Tap_All",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SalaryTableStatusType.All,
        active: tableView.tableStatusType == SalaryTableStatusType.All,
      },
      {
        name: "Table_Tap_Draft",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SalaryTableStatusType.Draft,
        active: tableView.tableStatusType == SalaryTableStatusType.Draft,
      },
      {
        name: "Table_Tap_AwaitApprove",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SalaryTableStatusType.AwaitApprove,
        active: tableView.tableStatusType == SalaryTableStatusType.AwaitApprove,
      },
      {
        name: "Table_Tap_Approved",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SalaryTableStatusType.Approved,
        active: tableView.tableStatusType == SalaryTableStatusType.Approved,
      },
      {
        name: "Table_Tap_Paid",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SalaryTableStatusType.Paid,
        active: tableView.tableStatusType == SalaryTableStatusType.Paid,
      },
      {
        name: "Table_Tap_Voided",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SalaryTableStatusType.Void,
        active: tableView.tableStatusType == SalaryTableStatusType.Void,
      },
    ];
  },
  SetHeaderSalaryTable(tableViewModel: any) {
    const header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Pay_Run_Code",
        sortBy: SalaryOrderType.Number,
        sortingType: null,
        width: 80,
        align: "flex-start",
      },
      {
        name: "Issed_Date",
        sortBy: SalaryOrderType.IssuedDate,
        sortingType: null,
        width: 100,
        align: "center",
      },
      {
        name: "Number_of_Employee",
        sortBy: SalaryOrderType.EmployeeCount,
        sortingType: null,
        width: 100,
        align: "flex-end",
      },
      {
        name: "Cycle_Date",
        sortBy: null,
        sortingType: null,
        width: 150,
        align: "center",
      },
      {
        name: "Payment_Date",
        sortBy: null,
        sortingType: null,
        width: 100,
        align: "center",
      },
      {
        name: "Payment_Amount",
        sortBy: SalaryOrderType.NetAmount,
        sortingType: null,
        width: 100,
        align: "flex-start",
      },
      {
        name: "Status",
        sortBy: null,
        sortingType: null,
        width: 100,
        align: "flex-start",
      },
    ];

    header.forEach((item) => {
      if (item.sortBy === tableViewModel.orderType) {
        item.sortingType = tableViewModel.sortingType;
      }
    });

    return header;
  },
  SetTapsSummarySalaryTable(tableView: SummarySalaryTableViewModel, tableCount: number) {
    return [
      {
        name: "Table_Tap_All",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SummarySalaryTableStatusType.All,
        active: tableView.tableStatusType == SummarySalaryTableStatusType.All,
      },
      {
        name: "Table_Tap_Voided",
        length: tableCount,
        bgLengthColor: "gray",
        showtableCount: false,
        tableViewStatusType: SummarySalaryTableStatusType.Void,
        active: tableView.tableStatusType == SummarySalaryTableStatusType.Void,
      },
    ];
  },
  SetHeaderSummarySalaryTable(tableViewModel: any) {
    const header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Doc_No_Summary",
        sortBy: SummarySalaryOrderType.Code,
        sortingType: null,
        align: "center",
      },
      {
        name: "Issed_Date",
        sortBy: SummarySalaryOrderType.CreateDateTime,
        sortingType: null,
        align: "center",
      },
      {
        name: "Cycle_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Number_of_Employee",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Number_of_Pay",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Net_amount_to_pay",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Status",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];

    header.forEach((item) => {
      if (item.sortBy === tableViewModel.orderType) {
        item.sortingType = tableViewModel.sortingType;
      }
    });

    return header;
  },
  SetHeaderSalaryTableForSummarySalary() {
    const header = [
      {
        name: "check",
        hidden: true,
        checkAll: false,
      },
      {
        name: "Pay_Run_Code",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Issed_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Number_of_Employee",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Cycle_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Payment_Date",
        sortBy: null,
        sortingType: null,
        align: "center",
      },
      {
        name: "Payment_Amount",
        sortBy: null,
        sortingType: null,
        align: "flex-end",
      },
      {
        name: "Status",
        sortBy: null,
        sortingType: null,
        align: "flex-start",
      },
    ];
    return header;
  },
  GetSalaryEmployeeRevenueDeductComponentList(
    revenueDeductList: Array<SalaryEmployeeRevenueDeductModel>,
    salaryEmployeeRevenueDeductComponentList: any,
  ) {
    const revenueDeductComponentList: any = [];
    if (salaryEmployeeRevenueDeductComponentList.length > 0) {
      salaryEmployeeRevenueDeductComponentList.forEach((component: any) => {
        const revenueDeductComponent = NewObject(component);
        const revenueDeduct = revenueDeductList.find(
          (x: SalaryEmployeeRevenueDeductModel) => x.revenueDeductId == revenueDeductComponent.revenueDeduct.value.id,
        );
        if (revenueDeduct) {
          const total =
            revenueDeduct.total *
            (revenueDeductComponent.revenueDeduct.value.revenueDeductType == RevenueDeductType.Deduction ? -1 : 1);
          revenueDeductComponent.total.value = total.PeakFormatMoney();
        }
        revenueDeductComponent.total.isDisabled = false;
        revenueDeductComponentList.push(revenueDeductComponent);
      });
    }
    return revenueDeductComponentList;
  },
  GetPaymentTransactionBankAccountDefault(netAmount = 0) {
    const paymentTransaction: PaymentTransactionBankAccountModel = {
      bankAccountId: 0,
      remark: "",
      paymentAmount: netAmount,
      isCheque: false,
      cheque: {
        chequeCode: "",
        chequeNumber: "",
        branchNumber: "",
        accountNumber: "",
        chequeDate: new Date(),
        chequeBankId: 0,
        chequePaymentDate: new Date(),
        contactId: 0,
      },
    };
    return paymentTransaction;
  },
  GetPaymentTransactionChartOfAccountDefault() {
    const paymentTransaction: PaymentTransactionChartOfAccountModel = {
      accountId: 0,
      remark: "",
      paymentAmount: 0,
    };
    return paymentTransaction;
  },
  GetPaymentTransactionChartOfAccountInPaymentModalDefault() {
    const paymentTransaction = {
      account: { id: 0 },
      paymentAmount: "0.00",
      selectedAdjustOption: { name: "Text_DeductAmount", value: 1 },
    };
    return paymentTransaction;
  },
  GetPaymentDefault() {
    const payment: PaymentModel = {
      paymentGroupDate: new Date().ToDateJsonString(),
      paymentTransactionBankAccountList: [],
      paymentTransactionChartOfAccountList: [],
    };
    return payment;
  },
  GetChartOfAccountPaymentNotDisplayPayment(accountList: any) {
    const chartOfaccountPaymentNotDisplayPaymentList: any = [];
    const chartaccountPaymentNotDisplayPayment = Object.values(ChartOfAccountPaymentNotDisplayPayment);
    accountList.forEach((account: any) => {
      const accountPayment = chartaccountPaymentNotDisplayPayment.find((item) => {
        return item == account.code ? true : false;
      });
      if (!accountPayment) {
        chartOfaccountPaymentNotDisplayPaymentList.push(NewObject(account));
      }
    });
    const seletedAccount = NewObject(chartOfaccountPaymentNotDisplayPaymentList[0]);
    return { option: chartOfaccountPaymentNotDisplayPaymentList, seletedAccount: seletedAccount };
  },
  GetPaidSSOPayment(input: any) {
    const payment: PaymentModel = this.GetPaymentDefault();
    payment.paymentGroupDate = input.paymentDate;
    const paymentTransactionBankAccount: PaymentTransactionBankAccountModel =
      this.GetPaymentTransactionBankAccountDefault();
    paymentTransactionBankAccount.bankAccountId = input.bankAccountId;
    paymentTransactionBankAccount.paymentAmount = input.netAmount;
    paymentTransactionBankAccount.isCheque = input.isCheque;
    paymentTransactionBankAccount.cheque = input.cheque;
    payment.paymentTransactionBankAccountList.push(paymentTransactionBankAccount);
    if (input.paymentTransactionChartOfAccountList && input.paymentTransactionChartOfAccountList.length > 0) {
      for (const paymentTransactionChartOfAccountInPaymentModal of input.paymentTransactionChartOfAccountList) {
        const paymentTransactionChartOfAccount: PaymentTransactionChartOfAccountModel =
          this.GetPaymentTransactionChartOfAccountDefault();
        paymentTransactionChartOfAccount.accountId = paymentTransactionChartOfAccountInPaymentModal.account.id;
        if (paymentTransactionChartOfAccountInPaymentModal.selectedAdjustOption.value == 2) {
          paymentTransactionChartOfAccount.paymentAmount =
            -1 * paymentTransactionChartOfAccountInPaymentModal.paymentAmount.ToNumber();
        } else {
          paymentTransactionChartOfAccount.paymentAmount =
            paymentTransactionChartOfAccountInPaymentModal.paymentAmount.ToNumber();
        }
        payment.paymentTransactionChartOfAccountList.push(paymentTransactionChartOfAccount);
      }
    }
    return payment;
  },
  GetPaidEWFPayment(input: any) {
    const payment: PaymentModel = this.GetPaymentDefault();
    payment.paymentGroupDate = input.paymentDate;
    const paymentTransactionBankAccount: PaymentTransactionBankAccountModel =
      this.GetPaymentTransactionBankAccountDefault();
    paymentTransactionBankAccount.bankAccountId = input.bankAccountId;
    paymentTransactionBankAccount.paymentAmount = input.netAmount;
    paymentTransactionBankAccount.isCheque = input.isCheque;
    paymentTransactionBankAccount.cheque = input.cheque;
    payment.paymentTransactionBankAccountList.push(paymentTransactionBankAccount);
    if (input.paymentTransactionChartOfAccountList && input.paymentTransactionChartOfAccountList.length > 0) {
      for (const paymentTransactionChartOfAccountInPaymentModal of input.paymentTransactionChartOfAccountList) {
        const paymentTransactionChartOfAccount: PaymentTransactionChartOfAccountModel =
          this.GetPaymentTransactionChartOfAccountDefault();
        paymentTransactionChartOfAccount.accountId = paymentTransactionChartOfAccountInPaymentModal.account.id;
        if (paymentTransactionChartOfAccountInPaymentModal.selectedAdjustOption.value == 2) {
          paymentTransactionChartOfAccount.paymentAmount =
            -1 * paymentTransactionChartOfAccountInPaymentModal.paymentAmount.ToNumber();
        } else {
          paymentTransactionChartOfAccount.paymentAmount =
            paymentTransactionChartOfAccountInPaymentModal.paymentAmount.ToNumber();
        }
        payment.paymentTransactionChartOfAccountList.push(paymentTransactionChartOfAccount);
      }
    }
    return payment;
  },
  IsValidatePaymentTransactionChartOfAccountList(paymentTransactionChartOfAccountList: any) {
    let isValidated = true;
    if (paymentTransactionChartOfAccountList && paymentTransactionChartOfAccountList.length > 0) {
      for (const paymentTransactionChartOfAccountInPaymentModal of paymentTransactionChartOfAccountList) {
        if (
          !(
            paymentTransactionChartOfAccountInPaymentModal.account &&
            paymentTransactionChartOfAccountInPaymentModal.account.id > 0
          )
        ) {
          isValidated = false;
        }
      }
    }
    return isValidated;
  },

  GetPaidSalaryPayment(input: any) {
    const payment: PaymentModel = this.GetPaymentDefault();
    payment.paymentGroupDate = input.paymentDate;
    const paymentTransactionBankAccount: PaymentTransactionBankAccountModel =
      this.GetPaymentTransactionBankAccountDefault();
    paymentTransactionBankAccount.isCheque = input.isCheque;
    paymentTransactionBankAccount.cheque = input.cheque;
    paymentTransactionBankAccount.bankAccountId = input.bankAccountId;
    paymentTransactionBankAccount.paymentAmount = input.netAmount;
    payment.paymentTransactionBankAccountList.push(paymentTransactionBankAccount);
    return payment;
  },

  ConvertToPaymentAndReferenceJournalDetail(paymentRaw: any, transactionId: number) {
    return ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId);
  },
  GetAutoCalculateWhtList(salary: any, employeeTotalYearlyList: Array<SalaryEmployeeTotalYearlyModel>) {
    const autoCalculateWhtList: any = [];
    const month = new Date(salary.dueDate.date).getMonth();
    salary.salaryEmployeeList.forEach((salaryEmployee: any) => {
      let salary = 0;
      let defaultWHT = 0;
      let revenueOther = 0;
      let deductOther = 0;
      let revenueOther402 = 0;
      let deductOther402 = 0;
      let grossSalaryAmount = 0;
      let taxCalculatedAmount = 0;
      let employeeTemplate: CreateEmployeeModel = GetCreateEmployeeTemplate();
      let totalAllowance = 0;
      let whtTotal = 0;
      if (salaryEmployee.employee.value && salaryEmployee.employee.value.id > 0) {
        employeeTemplate = GetEditEmployeeTemplate(salaryEmployee.employee.value);
        const allowanceData = GetAllowanceData(employeeTemplate);
        totalAllowance = GetTotalAllowance(allowanceData);
        salaryEmployee.revenueDeduct.revenueDeductList.forEach((revenueDeduct: any) => {
          if (revenueDeduct.revenueDeduct.value.type == DefaultRevenueDeductType.WithHoldingTax) {
            defaultWHT = revenueDeduct.total.value.ToNumber();
          }

          if (revenueDeduct.revenueDeduct.value.type == DefaultRevenueDeductType.Salary) {
            salary = revenueDeduct.total.value.ToNumber();
          }

          if (
            revenueDeduct.revenueDeduct.value.revenueDeductType == RevenueDeductType.Revenue &&
            revenueDeduct.revenueDeduct.value.taxRevenueCalculationType ==
              TaxRevenueCalculationType.IncludeIncomeType401 &&
            revenueDeduct.revenueDeduct.value.type !== DefaultRevenueDeductType.Salary
          ) {
            revenueOther += revenueDeduct.total.value.ToNumber();
          }

          if (
            revenueDeduct.revenueDeduct.value.revenueDeductType == RevenueDeductType.Deduction &&
            revenueDeduct.revenueDeduct.value.taxRevenueCalculationType ==
              TaxRevenueCalculationType.IncludeIncomeType401
          ) {
            deductOther += revenueDeduct.total.value.ToNumber();
          }

          if (
            revenueDeduct.revenueDeduct.value.revenueDeductType == RevenueDeductType.Revenue &&
            revenueDeduct.revenueDeduct.value.taxRevenueCalculationType ==
              TaxRevenueCalculationType.IncludeIncomeType402 &&
            revenueDeduct.revenueDeduct.value.type !== DefaultRevenueDeductType.Salary
          ) {
            revenueOther402 += revenueDeduct.total.value.ToNumber();
          }

          if (
            revenueDeduct.revenueDeduct.value.revenueDeductType == RevenueDeductType.Deduction &&
            revenueDeduct.revenueDeduct.value.taxRevenueCalculationType ==
              TaxRevenueCalculationType.IncludeIncomeType402
          ) {
            deductOther402 += revenueDeduct.total.value.ToNumber();
          }
        });

        if (employeeTotalYearlyList && employeeTotalYearlyList.length > 0) {
          const employeeTotalYearly = employeeTotalYearlyList.find(
            (x) => x.employeeId == salaryEmployee.employee.value.id,
          );

          if (employeeTotalYearly) {
            grossSalaryAmount = employeeTotalYearly.grossSalaryAmount;
            taxCalculatedAmount = employeeTotalYearly.taxCalculatedAmount;
            whtTotal = employeeTotalYearly.whtTotal;
          }
        }

        const autoCalculateWHT = AutoCalculateWhtSalaryCreate(
          salary.ToNumber(),
          taxCalculatedAmount,
          month,
          revenueOther,
          deductOther,
          revenueOther402,
          deductOther402,
          whtTotal,
          totalAllowance,
        );
        const input = {
          employeeId: salaryEmployee.employee.value.id,
          defaultWHT: defaultWHT,
          personalIncomeTaxPerMount: autoCalculateWHT.personalIncomeTaxPerMount,
          isRecommendWHT: defaultWHT.FormatMoney() !== autoCalculateWHT.personalIncomeTaxPerMount.FormatMoney(),
        };

        autoCalculateWhtList.push(input);
      }
    });
    return autoCalculateWhtList;
  },

  ConvertToSummarySalaryDetail(summarySalaryDetail: any) {
    const summarySalaryDetailModel: SummarySalaryDetailModel = {
      code: summarySalaryDetail.code,
      createDateTime: new Date(summarySalaryDetail.createDateTime),
      createUserId: summarySalaryDetail.createUserId,
      deductTotal: summarySalaryDetail.deductTotal,
      employeeCount: summarySalaryDetail.employeeCount,
      employeeList: [],
      fromDate: summarySalaryDetail.fromDate.NewDateTimeUct(),
      id: summarySalaryDetail.id,
      paymentAmount: summarySalaryDetail.paymentAmount,
      payrunCount: summarySalaryDetail.payrunCount,
      revenueTotal: summarySalaryDetail.revenueTotal,
      toDate: summarySalaryDetail.toDate.NewDateTimeUct(),
      merchantId: summarySalaryDetail.merchantId,
      salaryTotal: summarySalaryDetail.salaryTotal,
      whtTotal: summarySalaryDetail.whtTotal,
      socialSecurityEmployeeTotal: summarySalaryDetail.socialSecurityEmployeeTotal,
      socialSecurityEmployerTotal: summarySalaryDetail.socialSecurityEmployerTotal,
      socialSecurityPayableTotal: summarySalaryDetail.socialSecurityPayableTotal,
      whtPayableTotal: summarySalaryDetail.whtPayableTotal,
      isDeleted: summarySalaryDetail.isDeleted,
      userCredential: summarySalaryDetail.userCredential,
      merchantCredential: summarySalaryDetail.merchantCredential,
      employeeWelfareFundEmployeeTotal: summarySalaryDetail.employeeWelfareFundEmployeeTotal,
      employeeWelfareFundEmployerTotal: summarySalaryDetail.employeeWelfareFundEmployerTotal,
      employeeWelfareFundPayableTotal: summarySalaryDetail.employeeWelfareFundPayableTotal,
    };

    if (summarySalaryDetail.employeeList && summarySalaryDetail.employeeList.length > 0) {
      summarySalaryDetail.employeeList.forEach((employee: any, index: number) => {
        const salaryEmployee: SummarySalaryEmployeePayrunModel = {
          sequenceNumber: index + 1,
          whtCertificateId: employee.whtCertificateId,
          whtNumber: employee.whtNumber,
          revenueTotal: employee.revenueTotal,
          deductionTotal: employee.deductionTotal,
          personalCardNumber: employee.personalCardNumber,
          netIncomeTax: employee.netIncomeTax,
          netSSOTotal: employee.netSSOTotal,
          netIncomeTaxType401: employee.netIncomeTaxType401,
          netIncomeTaxType402: employee.netIncomeTaxType402,
          employeeId: employee.employeeId,
          code: employee.code,
          firstName: employee.firstName,
          lastName: employee.lastName,
          prefixName: employee.prefixName,
          identifyPersonCode: employee.identifyPersonCode,
          netAmount: employee.netAmountTotal,
          salaryTotal: employee.salaryTotal,
          whtTotal: employee.whtTotal,
          address: employee.address,
          subDistrict: employee.subDistrict,
          city: employee.city,
          province: employee.province,
          postCode: employee.postCode,
          revenueDeductList: [],
        };
        if (employee.revenueDeductList && employee.revenueDeductList.length > 0) {
          employee.revenueDeductList.forEach((revenueDeduct: SalaryEmployeeRevenueDeductPayRunModel) => {
            const revenueDeductEmployee: SalaryEmployeeRevenueDeductPayRunModel = {
              code: revenueDeduct.code,
              nameTh: revenueDeduct.nameTh,
              nameEn: revenueDeduct.nameEn,
              revenueDeductId: revenueDeduct.revenueDeductId,
              total: revenueDeduct.total,
              revenueDeductType: revenueDeduct.revenueDeductType,
            };
            salaryEmployee.revenueDeductList.push(revenueDeductEmployee);
          });
        }
        summarySalaryDetailModel.employeeList.push(salaryEmployee);
      });
    }
    return summarySalaryDetailModel;
  },
  CovertToWhtCertificateModel(whtCertificate: WhtCertificateModel) {
    const whtCertificateModel: WhtCertificateModel = {
      id: whtCertificate.id,
      createUserId: whtCertificate.createUserId,
      createDateTime: new Date(whtCertificate.createDateTime),
      approveUserId: whtCertificate.approveUserId,
      approveDateTime: new Date(whtCertificate.approveDateTime),
      whtNumber: whtCertificate.whtNumber,
      whtDate: new Date(whtCertificate.whtDate),
      conditionType: whtCertificate.conditionType,
      employeeId: whtCertificate.employeeId,
      paymentInOutFlowType: whtCertificate.paymentInOutFlowType,
      subTotal: whtCertificate.subTotal,
      whtTotal: whtCertificate.whtTotal,
      pensionFundAmount: whtCertificate.pensionFundAmount,
      socialSecurityAmount: whtCertificate.socialSecurityAmount,
      providentFundAmount: whtCertificate.providentFundAmount,
      isDeleted: whtCertificate.isDeleted,
      merchantId: whtCertificate.merchantId,
      itemModelList: Array<WhtCertificateItemModel>(),
      userCredential: whtCertificate.userCredential,
      merchantCredential: whtCertificate.merchantCredential,
      certifiedSetting: whtCertificate.certifiedSetting,
      netIncomeTaxType401: whtCertificate.netIncomeTaxType401,
      netIncomeTaxType402: whtCertificate.netIncomeTaxType402,
    };
    if (whtCertificate.itemModelList && whtCertificate.itemModelList.length > 0) {
      whtCertificate.itemModelList.forEach((item: WhtCertificateItemModel) => {
        const itemModel: WhtCertificateItemModel = {
          id: item.id,
          whtCertificateId: item.whtCertificateId,
          whtRate: item.whtRate,
          whtAmount: item.whtAmount,
          preTaxAmount: item.preTaxAmount,
          taxIncomeType: item.taxIncomeType,
          description: item.description,
        };
        whtCertificateModel.itemModelList.push(itemModel);
      });
    }
    return whtCertificateModel;
  },
  CovertToPndItemModel(pndItem: PndItemModel) {
    const pndItemModel: PndItemModel = {
      merchantId: pndItem.merchantId,
      employeeList: Array<SummarySalaryEmployeePayrunModel>(),
    };
    if (pndItem.employeeList && pndItem.employeeList.length > 0) {
      pndItem.employeeList.forEach((item: any, index: number) => {
        const itemModel: SummarySalaryEmployeePayrunModel = {
          sequenceNumber: index + 1,
          address: item.address,
          city: item.city,
          code: item.code,
          deductionTotal: item.deductionTotal,
          employeeId: item.employeeId,
          firstName: item.firstName,
          identifyPersonCode: item.identifyPersonCode,
          lastName: item.lastName,
          netAmount: item.netAmountTotal,
          netIncomeTax: item.netIncomeTax,
          netSSOTotal: item.netSSOTotal,
          personalCardNumber: item.personalCardNumber,
          postCode: item.postCode,
          prefixName: item.prefixName,
          province: item.province,
          revenueDeductList: item.revenueDeductList,
          revenueTotal: item.revenueTotal,
          salaryTotal: item.salaryTotal,
          subDistrict: item.subDistrict,
          whtCertificateId: item.whtCertificateId,
          whtNumber: item.whtNumber,
          whtTotal: item.whtTotal,
          netIncomeTaxType401: item.netIncomeTaxType401,
          netIncomeTaxType402: item.netIncomeTaxType402,
        };
        pndItemModel.employeeList.push(itemModel);
      });
    }
    return pndItemModel;
  },

  ConvertToEWFCreateModel(
    salaryDetail: SalaryDetailModel,
    masterRevenueDeductList: Array<RevenueDeductModel>,
  ): SalaryEWFDetailModel {
    const cloned: SalaryEWFDetailModel = JSON.parse(JSON.stringify(salaryDetail));

    const revenueDeductMap = new Map<number, RevenueDeductModel>();
    for (const item of masterRevenueDeductList) {
      revenueDeductMap.set(item.id, item);
    }

    cloned.employeeList = cloned.employeeList.map((employee) => {
      const updatedRevenueDeductList: SalaryEmployeeRevenueDeductEWFModel[] = employee.revenueDeductList.map((rd) => {
        const matched = revenueDeductMap.get(rd.revenueDeductId);
        return {
          ...rd,
          type: matched?.type ?? 0,
        };
      });

      return {
        ...employee,
        revenueDeductList: updatedRevenueDeductList,
      };
    });

    return cloned;
  },

  getBankAccountDisplayName(props: any) {
    if (!props) return "";
    let bankShortName = "";
    switch (props.bankAccountType) {
      case BankAccountType.Bank:
        const typeName = this.getBankAccountTypeName(props.bankType);
        bankShortName = `${props.bankShortName || props.bankName || ""} ${typeName} - ${props.bankNumber || ""} ${props.name || ""}`;
        break;
      default:
        bankShortName = props.name;
        break;
    }
    return bankShortName;
  },

  getBankAccountTypeName(bankType: number) {
    switch (bankType) {
      case BankType.CurrentAccount:
        return i18n.t("Current_account");
      case BankType.SavingAccount:
        return i18n.t("Saving_account");
      case BankType.FixedDeposit:
        return i18n.t("Fixed_deposit_account");
      default:
        return "";
    }
  },
};

export function SetTablePage(pageNumber: number, pageSize: number, detailList: Array<any>) {
  const start = pageNumber == 1 ? 0 : (pageNumber - 1) * pageSize;
  const end = pageSize * pageNumber;
  return detailList.slice(start, end);
}

export function GetEmployeeItem() {
  const employeeItem: SummarySalaryEmployeePayrunModel = {
    sequenceNumber: 0,
    employeeId: 0,
    code: "",
    firstName: "",
    lastName: "",
    prefixName: "",
    identifyPersonCode: "",
    revenueDeductList: [],
    personalCardNumber: "",
    netIncomeTax: 0,
    netSSOTotal: 0,
    whtCertificateId: 0,
    whtNumber: "",
    revenueTotal: 0,
    deductionTotal: 0,
    netAmount: 0,
    salaryTotal: 0,
    whtTotal: 0,
    address: "",
    subDistrict: "",
    city: "",
    province: "",
    postCode: "",
    netIncomeTaxType401: 0,
    netIncomeTaxType402: 0,
  };

  return employeeItem;
}

export function GetEmployeeItemForPaper() {
  const employeeItemForPaper: SummarySalaryEmployeePayrunForPaperModel = {
    employeeOne: GetEmployeeItem(),
    employeeTwo: GetEmployeeItem(),
    employeeThree: GetEmployeeItem(),
    employeeFour: GetEmployeeItem(),
    employeeFive: GetEmployeeItem(),
    employeeSix: GetEmployeeItem(),
    employeeSeven: GetEmployeeItem(),
    netTotal: 0,
    whtTotal: 0,
    netIncomeTaxType: NetIncomeTaxType.None,
  };
  return employeeItemForPaper;
}
